import {useLocation} from "react-router-dom";
import {useEffect} from "react";


export default function ScrollToTop() {
    const {pathname} = useLocation();

    useEffect(() => {
        let doc = document.getElementById('main-container');
        if (doc) {

            //   smooth scroll to top

            setTimeout(() => {
                doc.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },2000);


        }
    }, [pathname]);

    return null;
}